import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/node_modules/@mui/material-nextjs/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/node_modules/@next/third-parties/dist/google/ga.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/node_modules/@next/third-parties/dist/google/gtm.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/node_modules/@next/third-parties/dist/ThirdPartyScriptEmbed.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/node_modules/next/font/google/target.css?{\"path\":\"src/app/[locale]/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"display\":\"swap\",\"adjustFontFallback\":false,\"fallback\":[\"Arial\",\"Times New Roman\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/codebuild/output/src992805003/src/alouette/node_modules/nextjs-toploader/dist/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/codebuild/output/src992805003/src/alouette/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/outputs/All_Bands.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/outputs/Elevation.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/outputs/True_Colour_Image.jpg");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/resolution/10m.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/resolution/30cm.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/resolution/3m.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/public/images/resolution/70cm.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/assets/img/area1.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/assets/img/area2.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/assets/img/area3.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/assets/img/area4.png");
;
import(/* webpackMode: "eager" */ "/codebuild/output/src992805003/src/alouette/src/assets/scss/_skywatch.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/src/components/header/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/src/components/spinner/spinner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthenticationProvider"] */ "/codebuild/output/src992805003/src/alouette/src/context/authenticationProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DataManagementProvider"] */ "/codebuild/output/src992805003/src/alouette/src/context/dataManagementContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProviderLibraryProvider"] */ "/codebuild/output/src992805003/src/alouette/src/context/providerLibraryContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ShoppingCartProvider"] */ "/codebuild/output/src992805003/src/alouette/src/context/ShoppingCartContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SpinnerContextProvider"] */ "/codebuild/output/src992805003/src/alouette/src/context/SpinnerContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/src/features/hub-agent/components/AgentPanel/AgentPanel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AgentProvider"] */ "/codebuild/output/src992805003/src/alouette/src/features/hub-agent/context/AgentContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/src/i18n/TranslationsProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/codebuild/output/src992805003/src/alouette/src/lib/muiRegistry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReactScan"] */ "/codebuild/output/src992805003/src/alouette/src/services/reactScan.tsx");
